export const meetingsDated = date => {
  return `query {
    meetingsDated(date: ${date}) {
      id,
      date,
      type,
      tabIndicator
      externalIDs(sources: "gbs"){
        id
      },
      track {
        name,
        country,
      },
      races {
        number,
        id,
        name,
        status,
        startTime,
        distance,
        trackCondition,
        starters
      }
    }
  }`
}

export const meetingJockeys = meetingID => {
  return `query {
    meeting(id: ${meetingID}) {
      races {
        competitors {
          jockey
        }
      }
    }
  }`
}

export const queryRace = (id) => {
  return `query {
    race(id: ${id}){
      id
      name,
      number,
      startTime,
      status,
      trackCondition,
      distance,
      competitors{
        name,
        jockey,
        tabNo,
        scratched
      },
      meeting{
        id,
        type,
        date,
        tabIndicator,
        externalIDs(sources: "gbs"){
          id
        },
        track{
          name,
          country
        }
      },
    }
  }`
}

export const subscribeRaceUpdates = (date) => {
  return `subscription {
    raceUpdated(dated: ${date}){
      id,
      startTime,
      status,
      externalIDs(sources: "gbs"){
        id
      }
    }
  }`
}

export const subscribeDetailedRace = (id, date) => {
  return `subscription {
    raceUpdated(raceId: ${id}, dated: ${date}){
      id,
      number,
      name,
      startTime,
      status,
      trackCondition,
      distance,
      competitors{
        tabNo,
        name,
        jockey,
        scratched
      },
      meeting{
        id,
        type,
        date,
        tabIndicator,
        externalIDs(sources: "gbs"){
          id
        },
        track{
          name,
          country,
        }
      }
    }
  }`
}

/* export const subscribeRaceUpdates = `subscription {
  raceUpdated {
    distance,
    id,
    meeting {
      externalIDs(sources: "gbs"){
        id
      },
      id
      track {
        country,
        name
      },
      type
    }
    name,
    number,
    startTime,
    status,
    trackCondition
  }
}` */

export const bookies = `query {
  sources {
    code,
    name,
    gbsCode,
    isPriceSource
  }
}`

export const sportTypes = `query {
  sportTypes {
    id,
    name
  }
}`

/* export const sportCategories = (id) => {
  return `query {
    sportCategories(sportTypeId: ${id}) {
      id,
      name,
      description,
      sport_type {
        id,
        name
      }
      competitions {
        id,
        name,
        description,
        category {
          id,
          name,
          description
        },
        events {
          id,
          name,
          season,
          round,
          teams {
            id,
            name,
            position,
            players {
              id,
              name,
              first_name,
              last_name
            }
          },
          markets {
            id,
            name,
            status,
            type,
            description
          }
        }
      }
    }
  }`
} */

export const sportCategories = (id) => {
  return `query {
    sportCategories(sportTypeId: ${id}) {
      id,
      name,
      competitions {
        id,
        name,
        events {
          id,
          name,
          start_date
        }
      }
    }
  }`
}

export const sportMarkets = (id) => {
  return `query {
    sportMarkets (eventId: ${id}) {
      id,
      name,
      status,
      market_type {
        name
      }
      description,
      selections {
        id,
        name,
        status
      }
    }
  }`
}
